import React, { lazy } from 'react';
import { Route } from 'react-router-dom';
import AboutPageHandler from './AboutPageHandler';

// const BinderPage = lazy(() => import('./BinderPage').then((module) => ({ default: module.BinderPage })));

export const routes = [<Route key="1" path="/properties/:propertyId/about" component={AboutPageHandler} />];
